<template>
    <div :class="mobile ? $style['mobile-menu'] : $style['desktop-menu']">
        <Items
            :mobile="mobile"
            :menu-items="patchedMenuItems"
            parent-last
            :level="0"
        ></Items>
        <div :class="$style['after-menu-container']">
            <slot name="after-menu"></slot>
        </div>
    </div>
</template>

<style module>
.mobile-menu {
    margin-top: 15px;
}

.mobile-menu .after-menu-container:not(:empty) {
    margin-top: 30px;
}

.desktop-menu {
    position: relative;
}
</style>

<script setup lang="ts">
import { type PropType, ref, watch } from "vue";
import { patchMenuItems, type MenuItem } from "./menu-item";
import Items from "./items.vue";

const props = defineProps({
    menuItems: {
        type: Array as PropType<MenuItem[]>,
        required: true,
    },
    mobile: Boolean,
});

const patchedMenuItems = ref(patchMenuItems(props.menuItems));

watch(
    () => props.menuItems,
    (newValue) => {
        patchedMenuItems.value = patchMenuItems(newValue);
    }
);
</script>
